// @flow

import { handleListRequest } from '../phasedActionHelpers';

import type { LoadEpochsAction } from '../../actions/epoch';

export type State = {|
  +loading: boolean,
  +loaded: boolean,
|};

const initialState = {
  loading: false,
  loaded: false,
};

export default function epochs(state: State = initialState, action: LoadEpochsAction) {
  if (action.type === 'FETCH_EPOCHS') {
    return handleListRequest(state, action, result => {
      return result;
    });
  }

  (action: empty);
  return state;
}
